<template>
  <div v-loading="loading" class="page-wrap">
    <el-row>
      <el-col :xs="24" :sm="24" :lg="22" :xl="20">
        <el-form label-position="top" size="large" :model="form" :rules="rules" ref="formRef">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Xronologiya turi" prop="chronology_type">
                <el-select class="form-select" v-model="form.chronology_type" placeholder="Tanlang">
                  <el-option v-for="type in chronologyTypes" :value="type.value" :key="type.value" :label="type.name"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Manzilli ro'yxat" prop="address_document">
                <el-input v-model="form.address_document" placeholder="Manzilli ro'yxat"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Loyihachini aniqlash e'lon berilgan sana" prop="address_document">
                <el-date-picker placeholder="Sana tanlang" style="width: 100%" v-model="form.manager_search_date"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Lot raqami" prop="lot_number">
                <el-input-number controls-position="right" placeholder="Lot raqami" style="width: 100%"
                                 v-model="form.lot_number"/>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Buyurtmachi" prop="orderer_id" v-if="board_id">
                <RemoteSearchSelect url="api/v1/chronology/orderers" :params="{board_id}" v-model="form.orderer_id"
                                    response-data-field="orderers"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Pudratchi" prop="contractor_id" v-if="board_id">
                <RemoteSearchSelect url="api/v1/chronology/contractors" :params="{board_id}"
                                    v-model="form.contractor_id" response-data-field="contractors"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Loyiha smeta hujjatlari" prop="estimate_document">
                <el-input placeholder="Loyiha smeta hujjatlari" v-model="form.estimate_document"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Loyihaning yakuniy bahosi" prop="final_sum">
                <el-input placeholder="Loyihaning yakuniy bahosi" v-model="form.final_sum" v-money="money"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Loyiha yakuni bo'yicha asoslantiruvchi hujjat" prop="final_sum_document">
                <el-input placeholder="Loyiha yakuni bo'yicha asoslantiruvchi hujjat"
                          v-model="form.final_sum_document"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Loyihaning qabul qilingan sanasi" prop="finished_date">
                <el-date-picker style="width: 100%" placeholder="Loyihaning qabul qilingan sanasi"
                                v-model="form.finished_date"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item>
                <el-button @click="$router.go(-1)">Ortga</el-button>
                <el-button type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";
import RemoteSearchSelect from "@/components/RemoteSearchSelect.vue";

export default {
  name: "ChronologyForm",
  components: {RemoteSearchSelect},
  data() {
    return {
      loading: false,
      chronologyTypes: [
        {
          name: 'GUKS',
          value: 'GUKS'
        },
        {
          name: 'Qurilish-ta\'mirlash',
          value: 'CONSTRUCTION'
        },
        {
          name: 'Savdo-sotiq',
          value: 'SALE'
        },
      ],

      editId: null,

      form: {
        initiative_id: null,
        chronology_type: "GUKS",
        address_document: null,
        orderer_id: null,
        manager_search_date: null,
        lot_number: null,
        estimate_document: null,
        contractor_id: null,
        final_sum: null,
        final_sum_document: null,
        finished_date: null
      },
      rules: {
        chronology_type: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        address_document: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        orderer_id: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        manager_search_date: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        lot_number: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        estimate_document: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        contractor_id: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        final_sum: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        final_sum_document: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ],
        finished_date: [
          {
            required: true, message: "Majburiy maydopn."
          }
        ]
      },

      board_id: null,

      money: {
        decimal: '.',
        thousands: ' ',
        prefix: '',
        suffix: '',
        precision: 0
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          let http;

          const formData = {...this.form, final_sum: parseFloat(this.form.final_sum.replace(/\s/g, ''))}
          if (this.form.id) {
            http = this.$http.put(`/api/v1/chronology/${this.form.id}`, formData)
          } else {
            http = this.$http.post('/api/v1/chronology', formData);
          }


          http.then(() => {
            ElNotification({
              title: 'Tabriklaymiz',
              message: 'Muvafaqiyatli saqlandi',
              type: 'success',
            })
            this.$router.go(-1)
          }).catch(({response}) => {
            ElNotification({
              title: 'Xatolik',
              message: response.data.message || "Iltimos, qayta urinib ko'ring.",
              type: 'error',
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    getChronology() {
      this.loading = true
      this.$http(`/api/v1/chronology/${this.editId}`).then(({data})=>{
        this.form = data
        for (const key in  this.form) {
          this.form[key] = data[key]
        }

      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.form.initiative_id = this.$route.params.initiativeId

    this.board_id = this.$route.query.board_id

    if (this.$route.query.edit_id) {
      this.editId = this.$route.query.edit_id
      this.getChronology()
    }
  }
}
</script>

<style scoped>
.form-select {
  width: 100%;
}
</style>
